const API_BASE_URL = 'https://server.good-jabi.com/'

export { API_BASE_URL }
